module.exports = __webpack_public_path__ + "static/media/vie_douce.0400b676.mp3";